/**
 * Cookie utilities for browser cookie management
 */

/**
 * Get a cookie value by name
 * @param name - The name of the cookie to retrieve
 * @returns The cookie value or null if not found
 */
export const getCookie = (name: string): string | null => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    const cookiePart = parts.pop();
    return cookiePart ? cookiePart.split(';').shift() || null : null;
  }
  return null;
};

/**
 * Get the current user cookie based on environment
 * @returns The parsed user data or null if not found or invalid
 */
export const getCurrentUserCookie = () => {
  let cookieName = "";
  
  if (process.env.REACT_APP_ENV === "production") {
    cookieName = "CurrentUser";
  } else if (process.env.REACT_APP_ENV === "staging") {
    cookieName = "CurrentUserStaging";
  } else if (process.env.REACT_APP_ENV === "dev") {
    cookieName = "CurrentUserDev";
  }

  if (!cookieName) return null;

  const userCookie = getCookie(cookieName);
  if (!userCookie) return null;

  try {
    return JSON.parse(userCookie);
  } catch (error) {
    console.error("Error parsing user cookie:", error);
    return null;
  }
};